import { connect } from 'react-redux';
import SidebarComponent from './sidebar.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarComponent);



// WEBPACK FOOTER //
// ./src/components/core/sidebar/sidebar.ts